import { Data, Request } from 'effect';
export class GetSpacesError {
    originalError;
    _tag = 'GetSpacesError';
    constructor(originalError) {
        this.originalError = originalError;
    }
}
export class SpacesParseError extends Data.TaggedError('@fixtuur/backpack/AspectConfigurationSpaceService/SpacesParseError') {
}
export const GetSpaces = Request.tagged('GetSpaces');
